<cm-material-node-io #nodeIo [disableEditingIfConnected]="true" [material]="$material()" [nodeId]="$nodeId()" [socket]="$socket()"> </cm-material-node-io>
